var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFolderOpen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5 5.85A1.15 1.15 0 0 0 3.85 7v10a1.15 1.15 0 0 0 2.3 0v-5A2.85 2.85 0 0 1 9 9.15h7.15V9A1.15 1.15 0 0 0 15 7.85h-4.352l-2-2zm4 5A1.15 1.15 0 0 0 7.85 12v5c0 .41-.086.798-.242 1.15H19A1.15 1.15 0 0 0 20.15 17v-5A1.15 1.15 0 0 0 19 10.85zm-4 9A2.85 2.85 0 0 1 2.15 17V7A2.85 2.85 0 0 1 5 4.15h4.352l2 2H15A2.85 2.85 0 0 1 17.85 9v.15H19A2.85 2.85 0 0 1 21.85 12v5A2.85 2.85 0 0 1 19 19.85z",
  clipRule: "evenodd"
})));
export default SvgFolderOpen;